module.exports = __webpack_public_path__ + "../resources/img/weather_fog.d21a4c08.svg";